module.exports = __webpack_public_path__ + "0656dc828345266eb42d34819261c8ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-fi360-nomadia.svg
// module id = 796
// module chunks = 0